if (process.env.NODE_ENV === "development") {
  require("./index.html");
}

require("./styles.scss");

var Typewriter = require("typewriter-effect/dist/core");
var $ = require("jquery");
require("jquery-ui/ui/effect");
require("./vendor/JQuery-viewport-checker/jquery.viewportchecker.min.js");

// page scrolling when nav is clicked
$("a.page-scroll").bind("click", function(event) {
  var $anchor = $(this);
  $("html, body")
    .stop()
    .animate(
      {
        scrollTop: $($anchor.attr("href")).offset().top - 50
      },
      1250,
      "easeInOutExpo"
    );
  event.preventDefault();
});

// Highlight the top nav as scrolling occurs
$("body").scrollspy({
  target: ".navbar-fixed-top",
  offset: 51
});

// Initialize affix and add an offset to add affix class on scroll
if ($("header").length) {
  $("#mainNav").affix({
    offset: {
      top: $("header").height() - 60
    }
  });
}

//if ($("#home-heading-typer").length) {
var app = document.getElementById("home-heading-typer");

var typewriter = new Typewriter(app, {
  loop: true
});

typewriter
  .typeString("Opportunities")
  .pauseFor(2000)
  .deleteAll()
  .typeString("Web Design")
  .pauseFor(2000)
  .deleteAll()
  .typeString("System Architecture")
  .pauseFor(2000)
  .deleteAll()
  .typeString("Data Analysis")
  .pauseFor(2000)
  .deleteAll()
  .typeString("Process Improvement")
  .pauseFor(2000)
  .deleteAll()
  .typeString("Development Team")
  .pauseFor(2000)
  .deleteAll()
  .typeString("Systems Integration")
  .pauseFor(2000)
  .start();
//}

$(".service-icon").viewportChecker({
  classToAdd: "animated fadeInDown",
  offset: 0
});



//////////////////
// WEBPACK FOOTER
// ./src/index.js
// module id = 22
// module chunks = 0